// extracted by mini-css-extract-plugin
module.exports = {"feedback":"Qt1Tx","highlight":"vyqqB","content":"VxbBu"};